/** API base URL. Если задан VITE_API_URL — берём оттуда, иначе по умолчанию staging. */
export const API_URL =
  (import.meta.env.VITE_API_URL as string | undefined) ?? 'https://api.melissa.ltd/api/v1';

export const TOKEN_STORAGE_KEY = 'melissa_admin_access_token';
export const STAFF_STORAGE_KEY = 'melissa_admin_staff';
